<mat-toolbar color="" class="example-toolbar primary-theme-color">
  <img *ngIf="configService.themeConfig.ImgUrl"
  [src]="configService.themeConfig.ImgUrl" alt="" width="180">
  <div id="bs-example-navbar-collapse-1">
    <div class="alg">
      <mat-menu #menu="matMenu" class="menu-list">
        <button (click)="viewAllCollection()" mat-menu-item>View all Collections</button>
        <button matTooltipPosition="above" matTooltip="{{col?.collectionName}}" mat-menu-item (click)="editCollection(col)"
          *ngFor="let col of collectionData" class="collection-item collection-name">
          <span>{{ col?.collectionName | slice: 0:20 }}</span>
        </button>
      </mat-menu>
    </div>

    <button mat-button routerLinkActive="tab-active">
      <mat-form-field>
        <mat-select [(value)]="selectedCollection" #select>
          <mat-select-filter *ngIf="select.focused" [array]="searchOptions" [displayMember]="'collectionName'"
            (filteredReturn)="filteredList = $event" placeholder="{{'headerNav.placeholder' | translate}}">
          </mat-select-filter>
          <button (click)="viewAllCollection()" mat-menu-item [disabled]="!collectionFlag['viewAllowed']">
            {{'headerNav.dropdownText' | translate}}</button>
          <mat-option [value]="item?.collectionName" *ngFor="let item of filteredList" matTooltipClass="my-custom-tooltip" matTooltip="{{item?.collectionName}}" matTooltipPosition="above"
            (click)="editCollection(item)">{{item?.collectionName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </button>
    <button *ngIf="roles" mat-button routerLinkActive="tab-active" [routerLinkActiveOptions]="{exact:true}"
    [routerLink]="['/collections/'+collectionuuIdToNavigate+'/home']"> {{'headerNav.link7' | translate}}</button>

    <button *ngIf="roles && Assessments['viewAllowed'] && assignedRole != 'Account Admin'" mat-button routerLinkActive="tab-active" [routerLinkActiveOptions]="{exact:true}"
      [routerLink]="['/collections/'+collectionuuIdToNavigate+'/assessments']"> {{'headerNav.link8' | translate}}</button>

    <button *ngIf="roles && Items['viewAllowed']" mat-button routerLinkActive="tab-active" [routerLinkActiveOptions]="{exact:true}"
      [routerLink]="['/collections/'+collectionuuIdToNavigate+'/items']"> {{'headerNav.link1' | translate}}</button>
    <button *ngIf="roles && Tests['viewAllowed']" mat-button routerLinkActive="tab-active"
      [routerLink]="['/collections/'+collectionuuIdToNavigate+'/test']">{{'headerNav.link2' | translate}}</button>
    <button *ngIf="roles && Tags['viewAllowed']" mat-button routerLinkActive=" tab-active"
      [routerLink]="['/collections/'+collectionuuIdToNavigate+'/tags']">{{'headerNav.link3' | translate}}</button>

    <!-- <button *ngIf="roles && Examinees['viewAllowed']" mat-button [matMenuTriggerFor]="menu2"><span>{{'headerNav.link4.link' | translate}}</span>
      <mat-icon class="menu-button">expand_more</mat-icon>
    </button>
    <mat-menu #menu2="matMenu" class="menu-list">
      <button mat-menu-item [routerLink]="['/examinee-group']">
        <span>{{'headerNav.link4.nav1' | translate}}</span>
      </button>
      <button mat-menu-item [routerLink]="['/examinees']">
        <span>{{'headerNav.link4.nav2' | translate}}</span>
      </button>
    </mat-menu> -->
    <button *ngIf="roles && Reports['viewAllowed'] && assignedRole != 'Account Admin'" mat-button routerLinkActive=" tab-active"
      [routerLink]="['/collections/'+collectionuuIdToNavigate+'/reports']" (click)="navigationRefresh()">{{'headerNav.link5' | translate}}</button>
    <button *ngIf="roles && Users['viewAllowed']" mat-button routerLinkActive="tab-active"
      [routerLink]="['/users']">{{'headerNav.link6' | translate}}</button>
  </div>


  <span class="spacer"></span>
  <button mat-icon-button [matMenuTriggerFor]="menuprofile" class="example-icon rm-btn-underline" aria-label="user icon">
    <mat-icon>person_outline</mat-icon>
  </button>
  <!-- <div class="logo2">
    <img *ngIf="configService.themeConfig.svaslogoUrl"
    [src]="configService.themeConfig.svaslogoUrl" alt="" width="150">
  </div> -->

  <mat-menu #menuprofile="matMenu">
    <div class="user-details">
      <div class="user-photo">
        <span class="menu-icon">
          <i-feather name="user"></i-feather>
        </span>
      </div>
      <div>
        <p class="user-name">{{ firstName + ' ' + lastName}}</p>
        <p class="user-email">{{emailId}}</p>
        <br>
        <b class="role-assigned">{{'headerNav.labelRole' | translate}}:  {{assignedRole}}</b>
      </div>
    </div>

    <button mat-menu-item routerLink="/change-password">
      <mat-icon>settings</mat-icon>
      <span>{{'headerNav.profile.option5' | translate}}</span>
    </button>
    <button mat-menu-item routerLink="/roles" *ngIf="rolesFlag['viewAllowed'] && (rolesFlag && rolesFlag['rolesAssigned']===accountAdmin)">
      <mat-icon>supervisor_account</mat-icon>
      <span>{{'headerNav.profile.option1' | translate}}</span>
    </button>
    <button mat-menu-item routerLink="/subscription" *ngIf="rolesFlag['viewAllowed'] && (rolesFlag && rolesFlag['rolesAssigned']===accountAdmin)">
      <mat-icon>loyalty</mat-icon>
      <span>{{'headerNav.profile.option2' | translate}}</span>
    </button>
    <button mat-menu-item (click)="LogOut()">
      <mat-icon>lock</mat-icon>
      <span>{{'headerNav.profile.option4' | translate}}</span>
    </button>
  </mat-menu>
</mat-toolbar>

